<template>
    <Tag v-if="show" :text="text" :classes="classes" />
</template>

<script>
import Tag from '@/Components/Elements/Tags/Tag.vue'
export default {
    name: 'AccessTag',

    components: {
        Tag,
    },

    props: {
        access: {
            type: Object,
            required: true,
        },
    },

    computed: {
        text() {
            return this.access.name
        },

        show() {
            return this.access.id != 'publicaccess'
        },

        classes() {
            return [
                'text-white font-medium',
                {
                    'bg-yellow-500 border-yellow-500':
                        this.access.id == 'authaccess',
                    'bg-danger border-danger': this.access.id != 'authaccess',
                },
            ]
        },
    },
}
</script>
